export default 'https://tme.understood.org/assets/outro.en.04671eff.vtt'